export class Student{
    age?: number;
    name?: string;
    status?: string;
    quizSession?: object;
    teacher: object;
    userId: string;
    studentId: string;
    teacherId: string;
    username: string;
    expPoints: number;
    studentReadingLevel: string;
}